const routeConfig = {
  Portal: {
    id: 'portal',
    path: 'portal'
  },
  DataPage: {
    path: 'page/',
    param: 'pageId'
  },
  DataGrid: {
    path: 'grid/',
    param: 'gridId'
  },
  DataStep: {
    path: 'step/',
    param: 'stepId'
  },
  DataTabs: {
    path: 'tabs/',
    param: 'tabsId'
  },
  DataTree: {
    path: 'tree/',
    param: 'treeId'
  },
  DataTile: {
    path: 'tile/',
    param: 'tileId'
  },
  Refresh: {
    path: 'refresh'
  },
  Redirect: {
    id: '_id'
  }
}

export default routeConfig
